/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as NotificationDefs from './defs.defs.js'

const $nsid = 'app.bsky.notification.putActivitySubscription'

export { $nsid }

/** Puts an activity subscription entry. The key should be omitted for creation and provided for updates. Requires auth. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    subject: l.string({ format: 'did' }),
    activitySubscription: l.ref<NotificationDefs.ActivitySubscription>(
      (() => NotificationDefs.activitySubscription) as any,
    ),
  }),
  l.jsonPayload({
    subject: l.string({ format: 'did' }),
    activitySubscription: l.optional(
      l.ref<NotificationDefs.ActivitySubscription>(
        (() => NotificationDefs.activitySubscription) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
